// extracted by mini-css-extract-plugin
module.exports = {"shimmer-effect":"LoadingSkeleton_shimmer-effect__3iTVz","loadingCardSwipeX":"LoadingSkeleton_loadingCardSwipeX__dP5aT"};